export class SsrsServerCommandModel {
  public Command: string;
  public Embed: boolean;
}



// WEBPACK FOOTER //
// ./src/app/report/models/SsrsServerCommandModel.ts